<template>
<div id="main">
<header>
    メッセージ
    <div class="h-left">
        <a @click="refresh"><img src="~@/assets/images/icon04.svg" /></a>
    </div>
</header>
<div id="wrap3" style="overflow: hidden">
    <header class="menu">
        <ul class="h-menu2 clearfix" v-if="type === 1">
            <li>マッチング中</li>
            <a @click="
            setType(2)
            ">
                <li>メッセージ交換中 <p class="alert" v-if="parseInt(userDetail.is_new_message) > 0"></p></li>
            </a>
        </ul>
        <ul class="h-menu2 clearfix" v-if="type === 2">
            <a @click="
            setType(1)
            ">
                <li>マッチング中</li>
            </a>
            <li>メッセージ交換中 <p class="alert" v-if="parseInt(userDetail.is_new_message) > 0"></p></li>
           
        </ul>
    </header>

    <div v-if="type === 1">
        <div v-for="(date, index) in dateTL" :key="index">
            <p style='font-size: 12px; padding: 2%;'>{{ date }}</p>
            <a @click="redirectChat(item, date, i)" v-for="(item, i) in arrayDate[date]" :key="i">
                <div class="list">
                    <div class="clearfix">
                        <div class="list-img"><img :src="getImageUrl(item.avatar_url)" /></div>
                        <div class="list-inf">
                            <table>
                                <tbody>
                                    <tr>
                                        <td>
                                            <p>
                                                <!-- <span v-if="item.is_new">
                                                    <span class="red b">NEW&nbsp;</span>
                                                </span> -->
                                                <span class="list-name">&nbsp;{{ getLiving(item.living_area) }} {{ item.display_name }} {{ item.age }}歳</span>
                                            </p>
                                        </td>
                                        <td width="64" style="text-align: end; position: relative;">
                                            <span v-if="parseInt(item.online) == IS_ONLINE">
                                                <span style="height: 10px; width: 10px" class="p-login"></span>
                                                <span style="font-size: 10px;">オンライン</span>
                                            </span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <p>
                                                <span v-if="parseInt(item.sex) === MALE" class="pink"> {{ getFieldProfile('income', item.income) }}&nbsp;</span>
                                                <span>
                                                    <span class="pink icon" v-if="parseInt(item.enabled_call) === IS_CALL"><i class="fas fa-phone"></i> 通話OK</span>&nbsp;
                                                    <span class="pink2 icon" v-if="parseInt(item.is_free) === IS_WAITING_FOR_MEET"><i class="fas fa-calendar-check"></i> 本日OK</span>
                                                </span>
                                            </p>
                                        </td>
                                        <td style="text-align: end;">
                                            {{ item.time_at }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="ellipsis" colspan="2">
                                            {{ item.mood_status_tmp }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                </div>
            </a>
        </div>
    </div>
    <div v-if="type === 2">
        <div v-for="(date, index) in dateTL2" :key="index">
            <p style='font-size: 12px; padding: 2%;'>{{ date }}</p>
            <a @click="redirectChat(item, date, i)" class="listitem" v-for="(item, i) in arrayDate2[date]" :key="i" style="display:block">
                <div class="list" style="position: relative; display:flex; padding-top: 16px;">
                    <div class="notice-label" v-if="parseInt(item.is_read) !== IS_READ_MESSAGE ">
                        <span class="notice-label-text">未読</span>
                    </div>
                    <swiper>
                        <swiper-slide>
                            <div class="clearfix">
                                <div class="list-img"><img :src="getImageUrl(item.avatar_url)" /></div>
                                <div class="list-inf">
                                    <table>
                                        <tr>
                                            <td>
                                                <p>
                                                    <!-- <span v-if="item.is_read == 2">
                                                        <span class="red b">未読</span>
                                                    </span> -->
                                                    <span class="list-name">                                                    
                                                        <span v-if="item.is_new">
                                                            <span class="red b">NEW&nbsp;</span>
                                                        </span>
                                                        {{ getLiving(item.living_area) }} {{ item.display_name }} {{ item.total_age }}歳
                                                    </span>
                                                </p>
                                            </td>
                                            <td width="64" style="text-align: end; position: relative;">
                                                <span v-if="parseInt(item.is_online) == IS_ONLINE">
                                                    <span style="height: 10px; width: 10px" class="p-login"></span>
                                                    <span style="font-size: 10px;">オンライン</span>
                                                </span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <p>
                                                    <span v-if="parseInt(item.sex) === MALE" class="pink"> {{ getFieldProfile('income', item.income) }}&nbsp;&nbsp;</span>
                                                    <span>
                                                        <span class="pink icon" v-if="parseInt(item.enabled_call) === IS_CALL"><i class="fas fa-phone"></i> 通話OK</span>
                                                    </span>
                                                </p>
                                            </td>
                                            <td style="text-align: end;">{{ item.send_at }}</td>
                                        </tr>
                                        <tr>
                                            <td colspan="2">
                                                <p v-if="parseInt(userDetail.sex) === MALE && parseInt(userDetail.is_subscription) !== IS_SUBSCRIPTION" class="red">
                                                    メッセージが届いております。
                                                </p>
                                                <p v-else-if="item.send_type !== 'call'">
                                                    <i class="fa fa-reply" aria-hidden="true"></i> {{ getMessageText(item.msg_text, item.send_type, item.send_id) }}
                                                </p>
                                                <p v-if="item.send_type === 'call' && item.supports_video == 1 && item.enabled_call == 1">
                                                    ビデオ通話をキャンセルしました。
                                                </p>
                                                <p v-if="item.send_type === 'call' && item.supports_video == 1 && item.enabled_call != 1">
                                                    TODO ビデオ通話しました。
                                                </p>
                                                <p v-if="item.send_type === 'call' && item.supports_video != 1 && item.enabled_call == 1">
                                                    音声通話をキャンセルしました。
                                                </p>
                                                <p v-if="item.send_type === 'call' && item.supports_video != 1 && item.enabled_call != 1">
                                                    TODO 音声通話しました。
                                                </p>
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                                <div class="pin" v-if="parseInt(item.is_pin_chat) === IS_PIN_CHAT"><i class="fa fa-thumb-tack" aria-hidden="true"></i></div>
                            </div>
                        </swiper-slide>
                        <swiper-slide>
                            <div class="flex-2">
                                <div @click="hiddenMessage(item)"><i class="fa fa-ban" aria-hidden="true"></i>非表示にする</div>
                                <div @click="pinChat(item)"><i class="fa fa-thumb-tack" aria-hidden="true"></i>トップに固定</div>
                            </div>
                        </swiper-slide>
                    </swiper>
                </div>
            </a>
        </div>
    </div>
    <infinite-loading v-if="type === 1" @infinite="getLikes" spinner="spiral" :identifier="infiniteIdLike">
        <template v-slot:no-more></template>
        <template v-slot:no-results>
            <div id="middle" style="width: 70%;">
                <p>マッチング中のお相手はまだいません。</p>
                <div class="btn1">
                    <a @click="$router.push('like')">マッチングする</a>
                </div>
            </div>
        </template>
    </infinite-loading>
    <infinite-loading v-if="type === 2" @infinite="getMessages" spinner="spiral" :identifier="infiniteIdMessage">
        <template v-slot:no-more></template>
        <template v-slot:no-results>
            <div id="middle" style="width: 70%;">
                <p>メッセージ交換中の<br>お相手はいません。</p>
                <div class="btn1">
                    <a @click="setType(1)">メッセージ交換を開始</a>
                </div>
            </div>
        </template>
    </infinite-loading>
</div>
</div>

<div id="chat" class="hidden">
    <chat v-if="isShowChat" :idUser="userChat.id" :codeUser="userChat.code" @close="closeChat"></chat>
</div>
<successDialog :active="isShowAlertProcessApprove" @close="isShowAlertProcessApprove = false">
    <template v-slot:message>
        <h3>現在年齢認証中です。</h3>
        <p>最大24時間かかります。</p>
    </template>
</successDialog>
<div class="loading-screen" v-if="isLoading">
    <div class="loader"></div>
</div>
</template>

<script>
import CONSTANTS from "@/constants";
import mixin from "@/mixin"
import "@/assets/js/swiped-events.js"
import {
    setMessageTab,
    getMessageTab,
    removeMessageTab,
} from '@/auth'

import chat from "./chat"

import {
    mapGetters,
    mapActions
} from "vuex";
import {
    Swiper,
    SwiperSlide,
} from 'swiper/vue';
import subscriptionAlert from "@/views/user/components/subscriptionAlert"
import subscription from '../profile/subscription'
import veryAge from '../profile/veryAge.vue'
import successDialog from '@/views/components/successDialog'
export default {
    components: {
        Swiper,
        SwiperSlide,
        chat,
        subscriptionAlert,
        subscription,
        veryAge,
        successDialog,
    },
    mixins: [mixin],
    data: () => ({
        type: 1,
        pageSize: CONSTANTS.DEFAULT_PAGE_SIZE,
        pageCurrent: 1,
        messages: [],
        IS_LIKE: CONSTANTS.IS_LIKE,
        IS_CALL: CONSTANTS.IS_CALL,
        IS_WAITING_FOR_MEET: CONSTANTS.IS_WAITING_FOR_MEET,
        IS_READ: CONSTANTS.IS_READ,
        FEMALE: CONSTANTS.FEMALE,
        MALE: CONSTANTS.MALE,
        IS_LOOK_AT_ME: CONSTANTS.IS_LOOK_AT_ME,
        IS_ONLINE: CONSTANTS.IS_ONLINE,
        IS_READ_MESSAGE: CONSTANTS.IS_READ_MESSAGE,
        IS_SUBSCRIPTION: CONSTANTS.IS_SUBSCRIPTION,
        likeList: [],
        pageCurrentMessage: 0,
        user: null,
        infiniteIdLike: +new Date(),
        infiniteIdMessage: +new Date(),
        IS_PIN_CHAT: CONSTANTS.IS_PIN_CHAT,
        isLoading: true,
        isShowChat: false,
        userChat: {
            id: null,
            code: null
        },
        scrollHeight: null,
        isShowAlertSubscription: false,
        isShowAlertVerifyAge: false,
        isShowAlertProcessApprove: false,
        arrayDate: [],
        dateTL: [],        
        arrayDate2: [],
        dateTL2: [],
        messageDetail: {
            date: null,
            index: null
        }
    }),
    mounted() {
        this.setFooter(true)
        if (getMessageTab()) {
            this.type = parseInt(getMessageTab());
            removeMessageTab();
        }
        this.userSeftId = this.userDetail.id; 

        if (this.sockets) {
            this.sockets.subscribe("server-chat-receive", async (data) => {
                this.sortMessage(data)
                this.userDetail.is_new_message = 1
            });
        }
    },
    emits: ['position_changed'],
    computed: {
        ...mapGetters(["metadata", "defaultToken", "userDetail"]),
    },
    watch: {
        isShowChat(val) {
            const body = document.getElementsByTagName('body')[0];
            if (val) body.style.overflow = "hidden";
            else body.style.overflow = "auto";
        },
        type() {
            // Scroll to Top when change type
            window.scrollTo(0, 0)
        }
    },
    methods: {
        ...mapActions({
            getDefaultToken: "user/getDefaultToken",
            setFooter: "layout/setFooter"
        }),
        getFieldProfile(field, id) {
            if (!this.metadata) return null
            let filedData = this.metadata.user_profile_list[field].filter((item) => {
                return parseInt(item.value) === parseInt(id);
            });
            if (filedData[0]) {
                return filedData[0].name;
            }
            return CONSTANTS.NOT_VALUE;
        },
        sortMessage(data) {
            this.messages.map(e => {
                if (parseInt(e.user_id) == parseInt(data.u_id)) {
                    e.msg_text = this.getMessageText(data.msg, data.type, data.u_id)
                    e.send_type = data.type
                    e.send_id = data.u_id
                    e.is_read = 2
                }
                return e
            })
            this.messages = this.messages.sort((a, b) => {
                if (new Date(a.send_date_time) > new Date(b.send_date_time)) return -1;
                if (new Date(a.send_date_time) < new Date(b.send_date_time)) return 1;
                return 0;
            });
            this.dateTL2 = this.messages.map(item => {
                return this.formatDateTime(item.send_date_time);
            })
            this.dateTL2 = Array.from(new Set(this.dateTL2))
            for (let i = 0; i < this.dateTL2.length; i++) {

                let arr = this.messages.filter(e => {
                    return this.formatDateTime(e.send_date_time) == this.dateTL2[i]
                })
                if (arr.length > 0) {
                    this.arrayDate2[this.dateTL2[i]] = arr
                }
            }
        },
        getMessageText(message, type, userId) {
            switch (type) {
                case 'text':
                    return message
                case 'gift':
                    if (parseInt(userId) === parseInt(this.userDetail.id)) {
                        return CONSTANTS.SEND_MESSAGE_GIFT
                    }
                    return CONSTANTS.RECEIVE_MESSAGE_GIFT
                case 'image':
                    if (parseInt(userId) === parseInt(this.userDetail.id)) {
                        return CONSTANTS.SEND_MESSAGE_IMAGE
                    }
                    return CONSTANTS.RECEIVE_MESSAGE_IMAGE
                case 'location':
                    if (parseInt(userId) === parseInt(this.userDetail.id)) {
                        return CONSTANTS.SEND_MESSAGE_LOCATION
                    }
                    return CONSTANTS.RECEIVE_MESSAGE_LOCATION
                default:
                    break;
            }
        },
        closeSubscription() {
            this.setFooter(true)
            document.getElementById('subscription').classList.remove('show-right')
            document.getElementById('subscription').classList.add('hidden-right')
        },
        openSubscription() {
            this.isShowAlertSubscription = false
            document.getElementById('subscription').classList.add('show-right')
            document.getElementById('subscription').classList.remove('hidden-right')
        },
        openVerifyAge() {
            this.isShowAlertVerifyAge = false
            document.getElementById('very-age').classList.add('show-right')
            document.getElementById('very-age').classList.remove('hidden-right')
        },
        closeVerifyAge(val) {
            if (val) {
                this.user.is_verify_age = CONSTANTS.PC_VERY_AGE
            }
            this.setFooter(true)
            document.getElementById('very-age').classList.remove('show-right')
            document.getElementById('very-age').classList.add('hidden-right')
        },
        swiped(e) {
            // console.log('swiped', e)
        },
        closeChat(message) {
            if (message) {
                let msg = this.getMessageText(message.msg, message.type, message.u_id)
                if (this.arrayDate2[this.messageDetail.date] && this.arrayDate2[this.messageDetail.date][this.messageDetail.index]) {
                     this.arrayDate2[this.messageDetail.date][this.messageDetail.index].msg_text = msg
                    this.arrayDate2[this.messageDetail.date][this.messageDetail.index].send_type = message.type;

                    if (message.is_sent) {
                        this.arrayDate2[this.messageDetail.date][this.messageDetail.index].send_id = this.userDetail.id;
                    }
                }
            }
            setTimeout(() => {
                 window.scrollTo(0, this.scrollHeight);
            }, 1)
            this.isShowChat = false
            document.getElementById('chat').classList.remove('show')
            document.getElementById('chat').classList.add('hidden')
            this.setFooter(true)
            document.getElementById('main').style.display = "unset"

            if (document.getElementsByClassName('red b').length <= 0) {
                this.userDetail.is_new_message = 0
            }
        },
        redirectChat(item, date, i) {
            this.messageDetail.date = date
            this.messageDetail.index = i
            setMessageTab(this.type)
            
            if ( this.userDetail ) {
                if(item.is_read == CONSTANTS.NO_READ_MESSAGE) {
                    this.arrayDate2[date][i].is_read = CONSTANTS.IS_READ_MESSAGE
                }
                let userId = this.type === 1 ? item.id : item.user_id;
                this.userChat.id = userId
                this.userChat.code = item.user_code
                this.isShowChat = true
                this.scrollHeight = document.documentElement.scrollTop || document.body.scrollTop
                document.getElementById('main').style.display = "none"
                document.getElementById('chat').classList.add('show')
                document.getElementById('chat').classList.remove('hidden')
                this.setFooter(false)
            } 
        },
        refresh() {
            this.isLoading = true
            this.likeList = [];
            this.messages = [];
            this.pageCurrent = 1;
            this.pageCurrentMessage = 0;
            if (this.type === 1) {
                this.arrayDate = []
                this.dateTL = []
                this.infiniteIdLike++
            }
            if (this.type === 2) {
                this.arrayDate2 = []
                this.dateTL2= []
                this.infiniteIdMessage++
            }
        },
        setType(type) {
            this.isLoading = true
            this.messages = [];
            this.likeList = [];
            this.type = type;
            this.pageCurrent = 1;
            this.pageCurrentMessage = 0;
            if (this.type === 1) {
                this.infiniteIdLike++
            }
            if (this.type === 2) {
                this.infiniteIdMessage++
            }
        },
        async getLikes($state = null) {
            if (this.likeList.length > 0 && this.likeList.length < this.pageSize && $state) {
                $state.complete();
                return;
            }
            let params = {
                token: this.defaultToken,
                page: this.pageCurrent,
                limit: this.pageSize,
                type: 3,
            };
            await this.$store
                .dispatch("like/getLikes", params)
                .then((data) => {
                    if (data.length > 0) {
                        this.pageCurrent++;
                        this.likeList.push(...data)
                        this.likeList = this.likeList.sort((a, b) => {
                            if (new Date(a.send_date_time) > new Date(b.send_date_time)) return -1;
                            if (new Date(a.send_date_time) < new Date(b.send_date_time)) return 1;
                            return 0;
                        });
                        this.dateTL = this.likeList.map(item => {
                            return this.formatDateTime(item.send_date_time);
                        })
                        this.dateTL = Array.from(new Set(this.dateTL))
                        for (let i = 0; i < this.dateTL.length; i++) {

                            let arr = this.likeList.filter(e => {
                                return this.formatDateTime(e.send_date_time) == this.dateTL[i]
                            })
                            if (arr.length > 0) {
                                this.arrayDate[this.dateTL[i]] = arr
                            }
                            // console.log(this.arrayDate)
                        }
                        if ($state) {
                            $state.loaded();
                        }
                    } else {
                        if ($state) {
                            $state.complete();
                        }
                    }
                })
                .catch((err) => {
                    if ($state) {
                        $state.complete();
                    }
                });
            this.isLoading = false
        },
        async getMessages($state = null) {
            if (this.messages.length > 0 && this.messages.length < this.pageSize && $state) {
                $state.complete();
                return;
            }
            let params = {
                token: this.defaultToken,
                page: this.pageCurrentMessage,
                limit: this.pageSize,
            };
            await this.$store
                .dispatch("message/getMessages", params)
                .then((data) => {
                    if (data.result.length > 0) {
                        this.pageCurrentMessage++;
                        this.messages.push(...data.result)
                        this.messages = this.messages.sort((a, b) => {
                            if (new Date(a.send_date_time) > new Date(b.send_date_time)) return -1;
                            if (new Date(a.send_date_time) < new Date(b.send_date_time)) return 1;
                            return 0;
                        });
                        this.dateTL2 = this.messages.map(item => {
                            return this.formatDateTime(item.send_date_time);
                        })
                        this.dateTL2 = Array.from(new Set(this.dateTL2))
                        for (let i = 0; i < this.dateTL2.length; i++) {

                            let arr = this.messages.filter(e => {
                                return this.formatDateTime(e.send_date_time) == this.dateTL2[i]
                            })
                            if (arr.length > 0) {
                                this.arrayDate2[this.dateTL2[i]] = arr
                            }
                        }
                        if ($state) {
                            $state.loaded();
                        }

                    } else {
                        if ($state) {
                            $state.complete();
                        }
                    }
                })
                .catch((err) => {
                    if ($state) {
                        $state.complete();
                    }
                });
            this.isLoading = false
        },
        getLiving(id) {
            if (!this.metadata.user_profile_list) return;
            let living = this.metadata.user_profile_list.living_area.filter(
                (item) => {
                    return item.value === id;
                }
            );
            if (living[0]) {
                return living[0].name;
            }
            return null;
        },
        pinChat(item) {
            let formData = new FormData()
            formData.append('user_id', item.user_id)
            if (item.is_pin_chat === this.IS_PIN_CHAT) {
                formData.append('is_unpin', true)
            }
            formData.append('token', this.defaultToken)
            this.$store.dispatch('message/pinChat', formData).then(data => {
                this.refresh()
            })
        },
        hiddenMessage(item) {
            let formData = new FormData()
            formData.append('token', this.defaultToken)
            formData.append('user_mute_id', item.user_id)
            formData.append('type', CONSTANTS.HIDDEN_MESSAGE)
            this.$store.dispatch('profile/muteMessage', formData).then(data => {
                 this.refresh()
            }).catch(err => {
                // console.log(err)
            })
        }
    },
};
</script>

<style scoped>
.hidden {
    opacity: 0;
    width: 0px;
    transition: all 0.5;
}

.flex-2 {
    display: grid;
    grid-template-columns: 1fr 1fr;
    height: 100%;
}

.flex-2 div {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    display: flex;
    flex-direction: column;
}

.flex-2 div:nth-child(1) {
    background: #ccc;
}

.flex-2 div:nth-child(2) {
    background: #64c9d1;
}

.pin {
    top: 0;
    right: 5px;
    position: absolute;
}
.hidden {
    position: fixed;
    right: -100%;
    top: 0;
    width: 100%;
    opacity: 0;
    overflow: hidden;
}
.show {
    position: fixed;
    right: 0;
    top: 0;
    width: 100%;
    opacity: 1;
    overflow: auto;
}
 #chat {
    transition: right 0.2s;
    font-weight: 400;
}
.h-menu2 {
    position: unset;
}
#wrap3 {
    max-width: unset;
}
.menu {
    top: 42px;
}
.subscription {
    background: #fff;
    padding-bottom: 10px;
}
.subscription .content {
    padding: 20px;
}
.subscription .btn1 {
    color: #fff;
    padding: 10px;
}
.hidden-right {
    position: fixed;
    right: -100%;
    top: 0;
    width: 100%;
    overflow: hidden;
}
.show-right {
    position: absolute;
    right: 0;
    top: 0;
    width: 100%;
    overflow: hidden;
    z-index: 999999;
    background: #fff;
    overflow: scroll;
    height: 100vh;
}
#subscription, #very-age {
    transition: all 0.2s;
}
.alert {
    right: 5%;
}

.pink {
    font-size: 11px;
}

.pink.icon,
.pink2.icon {
    font-size: 10px;
}
.notice-label {
    position: absolute;
    top: 0;
    right: 0;
    border-width: 0px 30px 30px 0px;
    border-style: solid;
    border-color: transparent rgba(254,89,123,255);
    opacity: 1;
    color: white;
}

.notice-label-text {
    position: absolute;
    font-weight: bold;
    font-size: 11px;
    transform: rotateZ(45deg);
    top: 4px;
    left: 10px;
    width: 22px;
    font-size: 8px;
}
.ellipsis {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
#wrap3 {
    overflow-x: hidden;
}
</style>
